import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AUTH } from '@env';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Events } from 'ionic-angular';


@Injectable()
export class AuthProvider {

  public avatar: Observable<any>;
  private $avatar: Subject<any>;
  private headers: HttpHeaders;

  constructor(
    public http: HttpClient, 
    private storage: Storage,
    public events: Events,
  ) {
    this.$avatar = new Subject<any>();
    this.avatar = this.$avatar.asObservable();
    this.headers = new HttpHeaders({ 'HiddenLoading': 'yes'});
  }

  checkNewVersion(params): Promise<any> {
    return this.http.post(AUTH.CHECK_VERSION, params, { headers: this.headers } ).toPromise();
  }

  guardaInfoDevice(params): Promise<any> {
    return this.http.post(AUTH.DEVICE_INFO, params, { headers: this.headers } ).toPromise();
  }

  verificarSesion(params): Promise<any> {
    return this.http.post(AUTH.VERIFY, params, { headers: this.headers } ).toPromise();
  }

  recuperarContrasenia(correo: string): Promise<any> {
    return this.http.post(AUTH.RECUPERAR_CONTRASENIA , { correo }).toPromise();
  }

  cambiaContrasenia(jugador: any, contrasenia: string): Promise<any> {
    return this.http.post(AUTH.SET_PASSWORD + jugador, { contrasenia }).toPromise();
  }

  updatePlayerId(jugador: any, playerId: string): Promise<any> {
    return this.http.post(AUTH.UPDATE_PLAYER_ID + jugador, { playerId }, { headers: this.headers }).toPromise();
  }

  setAvatar(jugador: any, avatar: any): Promise<any> {
    return this.http.post(AUTH.SET_AVATAR + jugador, avatar).toPromise();
  }

  downloadAvatar(jugador: any): Promise<any> {
    return this.http.get(AUTH.DOWNLOAD_AVATAR + jugador).toPromise();
  }

  login(auth: any): Promise<any> {
    return this.http.post(AUTH.LOGIN, auth).toPromise();
  }

  getAreasJugador(user: any): Promise<any> {
    return this.http.get(`${AUTH.AREAS_JUGADOR}${user}`).toPromise();
  }

  saveAvatar(avatar: any) {
    this.$avatar.next(avatar);
    this.storage.set('avatar', avatar);
  }

  saveSession(jugador: any) {
    this.storage.set('jugador', jugador);
  }

  saveEquipo(equipo: any) {
    this.storage.set('equipo', equipo);
  }

  saveToken(token: string) {
    this.storage.set('token', token);
  }

  saveScorePersonal(score: number) {
    this.storage.set('scorePersonal', score);
  }

  getAvatar(): Promise<any> {
    return this.storage.get('avatar').then((avatar) => {
      if( !avatar ) {
        return null;
      }
      return avatar;
    });
  }

  getSession(): Promise<Jugador> {
    return this.storage.get('jugador').then((jugador) => {
      if( !jugador ) {
        return null;
      }
      return Object.assign(new Jugador, jugador);
    });
  }

  getEquipo(): Promise<Equipo> {
    return this.storage.get('equipo').then((equipo) => {
      if( !equipo ) {
        return null;
      }
      return Object.assign(new Equipo, equipo);
    });
  }

  getToken(): Promise<string> {
    return this.storage.get('token');
  }

  getScorePersonal(): Promise<number> {
    return this.storage.get('scorePersonal').then((score) => {
      if( !score ) {
        return 0;
      }
      return +score;
    });
  }

  cerrarSesion(): Promise<any> {
    return this.storage.clear();
  }

  setWinner(winner: any) {
    this.storage.set('winner', winner);
  }

  getWinner(): Promise<any> {
    return this.storage.get('winner').then((winner) => {
      if( !winner ) {
        return null;
      }
      return winner;
    });
  }

  changeArea(boolean: boolean) {
    this.storage.set('changeArea', boolean);
  }

  isChangeArea(): Promise<boolean> {
    return this.storage.get('changeArea').then((changeArea) => {
      return changeArea ? true: false;
    });
  }

  setMostrarModalVersion(apariciones: number) {
    this.storage.set('modalVersion', apariciones);
  }

  mostrarModalVersion(): Promise<number> {
    return this.storage.get('modalVersion').then((modalVersion) => {
      return modalVersion ? +modalVersion : 0;
    });
  }

  async getOnboardingMostrado(): Promise<any> {
    return this.storage.get('onboarding')
  }

  ocultaOnboarding(): Promise<any> {
    return this.storage.set('onboarding', true );
  }

  async saveColorsNormalMode(colors: any): Promise<any> {
    await this.storage.set('colorsNormalMode', colors );
    this.events.publish('color:updated', true);
  }

  getColorsNormalMode(): Promise<any> {
    return this.storage.get('colorsNormalMode');
  }

  async saveColorsCampaignMode(colors: any): Promise<any> {
    await this.storage.set('colorsCampaignMode', colors );
    this.events.publish('color:updated', true);
  }

  getColorsCampaignMode(): Promise<any> {
    return this.storage.get('colorsCampaignMode');
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts